import { RouteConfig } from 'vue-router'

const ExamEnterProcessProjects = () => import('../views/exam/EnterProcessProjetstList.vue')
const ExamEnterProcessGradeList = () => import('../views/exam/EnterProcessGradeList.vue')
const ExamEnterProcessClazzDetail = () => import('../views/exam/EnterProcessClazzDetail.vue')
const ExamEnterProcessResultEntry = () => import('../views/exam/EnterProcessResultEntryPage.vue')
const ExamEnterProcessOrderSet = () => import('../views/exam/EnterProcessOrderSetPage.vue')

const examEnterProcessProjectsRoute: RouteConfig = {
  path: '/exam-enter-process-projects',
  name: 'exam_enter_process_projects',
  component: ExamEnterProcessProjects,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNo: Number(route.query.gradeNo),
    classNo: Number(route.query.classNo),
  }),
  meta: {
    title: '体侧项目列表',
  },
}

const examEnterProcessGradesRoute: RouteConfig = {
  path: '/exam-enter-process-grades',
  name: 'exam_enter_process_grades',
  component: ExamEnterProcessGradeList,
  props: (route) => ({ ...route.query, ...route.params }),
}

const examEnterProcessClazzRoute: RouteConfig = {
  path: '/exam-enter-process-clazz',
  name: 'exam_enter_process_clazz',
  component: ExamEnterProcessClazzDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
    gradeNo: Number(route.query.gradeNo),
    classNo: Number(route.query.classNo),
  }),
}

const examEnterProcessResultEntryRoute: RouteConfig = {
  path: '/exam-enter-process-result-entry',
  name: 'exam_enter_process_result_entry',
  component: ExamEnterProcessResultEntry,
  props: (route) => ({ ...route.query, ...route.params, isMulti: JSON.parse(route.query.isMulti as string) }),
  meta: {
    title: '录入成绩',
  },
}

const examEnterProcessOrderSetRoute: RouteConfig = {
  path: '/exam-enter-process-order-set',
  name: 'exam_enter_process_order_set',
  component: ExamEnterProcessOrderSet,
  meta: {
    title: '排序设置',
  },
}

export default [
  examEnterProcessProjectsRoute,
  examEnterProcessGradesRoute,
  examEnterProcessClazzRoute,
  examEnterProcessResultEntryRoute,
  examEnterProcessOrderSetRoute,
]
